(function () {
	'use strict';

	var rand = function(from, to) {
		return Math.floor(from + Math.random() * (to - from));
	}

	var S, C = Onicon.core, P = Onicon.protocol, TR = Onicon.transport, LS = Onicon.local_storage, trigger = Onicon.trigger, DS = Onicon.datesync;
	var BackUp = function () {
		var prepared = {
			autosends : S.autosends,
			operators : S.operators,
			hash : S.last_synced_hash
		};
		LS.set('sas_' + Onicon.LOADER_PARAMS.site_id, prepared);
	};
	var Restore = function () {
		var cached_data = LS.get('sas_' + Onicon.LOADER_PARAMS.site_id);
		if(cached_data) {
			S.autosends = cached_data.autosends;
			S.operators = cached_data.operators;
			S.last_synced_hash = cached_data.hash;
		}
	};

	S = {
		autosends: {},
		operators : {},
		last_synced_hash : null,
		server_hash : null,

		prepared_to_send : null,

		autosends_timer: null,

		user_typing: false,

		current_sending_autosend: '',

		disabled : false,
		sas_event : '',
		typing: false,

		init : function() {
			if(Onicon.cookie.get('NO_ONICON_AUTOSEND')) {
				Onicon.log('[sas] Sas disabled by global cookie');
				return;
			}

			var recheck = function() {
				S.sender();
			};

			trigger.bind(trigger.EV_WORKING, function() {
				S.syncAutosends();
			});

			trigger.bind(trigger.EV_V_VISITOR_TYPING, function() {
				S.typing = true;
			});

			trigger.bind(trigger.EV_V_OPERATOR_LEAVE_CHAT, recheck);
			trigger.bind(trigger.EV_V_OPERATOR_LEAVE_SITE, recheck);
			trigger.bind(trigger.EV_V_OPERATOR_COME_TO_CHAT, recheck);

			trigger.bind(trigger.EV_V_USER_UPDATED, recheck);

			trigger.bind(trigger.EV_V_VISITOR_TYPING, function() {
				S.sas_event = 'event_typing';
				recheck();
			});

			trigger.bind(trigger.EV_V_PANEL_SHOW, function() {
				S.sas_event = 'event_show_panel';
				recheck();
			});

			trigger.bind(trigger.EV_V_PANEL_HIDE, function() {
				S.sas_event = 'event_hide_panel';
				recheck();
			});

            trigger.bind(trigger.EV_V_SITE_CLOSE, function() {
                S.sas_event = 'event_site_close';
                recheck();
            });

			trigger.bind(trigger.EV_PACKET, S.packet);

			// Это внешние эвенты, генерируемые другими компонентами системы, поэтому не имеют кодов
			trigger.bind('sas_disable', function() {
				S.disabled = true;
			});

			trigger.bind('sas_enable', function() {
				S.disabled = false;
				recheck();
			});
		},

		getSas : function(sas_id) {
			if(S.autosends[sas_id]) {
				return S.autosends[sas_id];
			} else {
				return null;
			}
		},

		packet: function (d) {
			var i, ls = S.autosends, o, j;

			switch (d.flag) {
				case P.SERVER_CODE_AUTHORIZATION_DONE:
					if(d.sas_hash) {
						S.server_hash = d.sas_hash;
					}
					break;

				case P.SERVER_CODE_CHAT_MESSAGE:
					var autosend_id = d.message.autosend;
					if(autosend_id) {
						Onicon.log('[sas] Packet: sasf send success; current sending: ', S.current_sending_autosend, '; sended autosend: ' + autosend_id);
						if (S.current_sending_autosend && S.current_sending_autosend.id === autosend_id) {
							S.current_sending_autosend = null;
						}

						if(S.autosends[autosend_id]) {
							trigger.execute('sas_autosend_sended', S.autosends[autosend_id]);
						}
					}
					S.current_sending_autosend = null;
					S.sender();
					break;

				case P.SERVER_CODE_SASF_SEND_ERROR:
					Onicon.error('[sas] Packet: sasf send error; current sending: ', S.current_sending_autosend);
					break;

				case P.SERVER_CODE_SASB_UPDATED:
					switch (d.type) {
						case 'sas_activated':
							if(S.autosends[d.sas_id])	{
								S.autosends[ d.sas_id ].enabled = !!d.enabled;
							}
							break;
						case 'sas_created':
							if(!S.autosends[d.sas_id]) {
								S.autosends[d.sas_id] = d.sas;
							}
							break;
						case 'sas_updated':
							if(S.autosends[d.sas_id])	{
								for(var prop_name in d.sas) {
									if(d.sas.hasOwnProperty(prop_name)) {
										S.autosends[d.sas_id][prop_name] = d.sas[prop_name];
									}
								}
							}
							break;
						case 'sas_deleted':
							if(S.autosends[d.sas_id])	{
								S.removeAutosendById(d.sas_id);
							}
							break;
						case 'sas_reordered':
							if(d.order) {
								for(var sas_id in d.order) {
									var sas_order = d.order[sas_id];
									S.autosends[sas_id].order = sas_order;
								}
							}
							break;
					}

//					BackUp(); // Бэкапить просто бесполезно, ибо ХЭШ уже не сойдется с серверным, так что забьем
					S.sender();
					break;

				case P.SERVER_CODE_SASF_SYNC_ERROR:
					Onicon.error('[sas] Packet: received sasf_sync_error');
					return;

				case P.SERVER_CODE_SASF_SYNC:
					Onicon.log('[sas] Packet: received sasf_sync', d);
					S.autosends = d.autosends;
					S.operators = d.operators;
					S.last_synced_hash = d.hash;
					BackUp();

					trigger.execute(trigger.EV_V_SAS_LOADED);

					S.sender();
					break;
			}
		},

		removeAutosendById : function(sas_id) {
			if(S.autosends[sas_id]) {
				delete(S.autosends[sas_id]);
			}
		},

		syncAutosends: function () {
			Restore();
			Onicon.log('[sas] Sync: init  last hash: ', S.last_synced_hash, 'server hash', S.server_hash);

			if(!S.last_synced_hash || S.last_synced_hash != S.server_hash) {
				Onicon.log('[sas] Need to sync, sending packet');
				TR.send({
					flag: P.CLIENT_CODE_SASF_SYNC
				});
			} else {
				Onicon.log('[sas] NO Need to sync, can watch TV and play games');
				trigger.execute(trigger.EV_V_SAS_LOADED);
				S.sender();
			}
		},

		sender_WDT_data : {},
		sender_WDT : function() {
			var minute = (new Date()).getMinutes();
			if(!S.sender_WDT_data[minute]) {
				S.sender_WDT_data[minute] = 0;
			}

			S.sender_WDT_data[minute]++;
			if(S.sender_WDT_data[minute] > 200) {
				return false;
			}

			if(minute > 0) {
				var prev_minute = minute - 1;
				if(S.sender_WDT_data[prev_minute]) {
					delete(S.sender_WDT_data[prev_minute]);
				}
			} else {
				if(S.sender_WDT_data[59]) {
					delete(S.sender_WDT_data[59]);
				}
			}

			return true;
		},
		// Это recheck
		sender: function () {
			Onicon.log('[sas] Sender: new loop started', S.sas_event);

			clearTimeout(S.autosends_timer);
			S.autosends_timer = null;
//
//			if(!S.sender_WDT()) {
//				Onicon.error('WDT Error');
//				return false;
//			}

			// Это выключатель, который могут использовать другие компоненты системы, такие как ИП и ТД и ТП :)
			if(S.disabled) {
				Onicon.log('[sas] Sender: sas temporary disabled');
				return;
			}

			// В данные момент уже отправляется авторассылка, необходимо дождаться успеха или провала данной операции
			if (S.current_sending_autosend) {
				Onicon.log('[sas] Sender: autosend sending now, wait...');
				return;
			}


			var in_m = 0, out_m = 0, as_m = 0;
			var sended_autosends = {};
			var last_visitor_message = 0, last_operator_message = 0, last_autosend_time = 0, last_operator_id = null;
			for (var i = 0; i < C.channels.chat.messages.length; ++i) {
				var mess = C.channels.chat.messages[i];
				var send_time = DS.correct(mess.post_date);

				// Посчитаем сколько сейчас рельно сообщений в истории
				if (mess.sender_type === P.TYPE_OPERATOR) {
					++in_m;
				} else {
					++out_m;
				}

				// Какие авторассылки уже были и когда отправлялись
				if (mess.autosend) {
					++as_m;
					if(!sended_autosends[mess.autosend]) {
						sended_autosends[mess.autosend] = send_time;
					} else if(send_time > sended_autosends[mess.autosend]) {
						sended_autosends[mess.autosend] = send_time;
					}

					if(send_time > last_autosend_time) {
						last_autosend_time = send_time;
					}
				}

				// КОгда было последнее сообщение от оператора и когда от посетителя
				if(mess.sender_type == P.TYPE_OPERATOR) {
					last_operator_message = send_time;
					last_operator_id = mess.sender_id;
				} else if(mess.sender_type == P.TYPE_VISITOR) {
					last_visitor_message = send_time;
				}
			}

			var ag_Autosends = LS.get('ag-sended:'+C.channels.chat.channel_id+C.session_start);
            if (ag_Autosends) {
                for (var ags in ag_Autosends) {
                    sended_autosends[ags] = ag_Autosends[ags];
                }
            }

			var curtime = Math.floor(+(new Date())/1000);

			// Некоторые предварительно посчитанные вещи, чтобы не прогонять их каждый раз
			var calculated_data = {
				as_m : as_m,
				in_m : in_m,
				out_m : out_m,
				sended_autosends: sended_autosends,
				last_visitor_message: last_visitor_message,
				last_operator_message: last_operator_message,
				last_autosend_time: last_autosend_time,
				last_operator_id: last_operator_id
			};

			// Готовая к отправке авторассылка (не важно сейчас или через сколько-то времени)
			var prepared_sas = null;

			// Проходим все авторассылки, с целью обнаружить годные к отправке
			for (var sas_id in S.autosends) {

				if(!S.autosends.hasOwnProperty(sas_id)) {
					continue;
				}

				var sas = S.autosends[sas_id];
				var time_offset = 0;

				Onicon.log('[sas] Sender: check autosend with id ' + sas._id + ' ' + sas.title, sas);

				// Проверяем авторассылку на все правила + генерируем отправителя
				var check_result = S._checkAutosend(sas, calculated_data);

				// Если нашлась годная авторассылка
				if(check_result) {
					var time_offset = check_result.time_offset;

					var sas_time = time_offset + curtime;
					// И либо она первая такая красивая, либо ее задержка меньше, либо задержка такая-же но порядок меньше
					if(!prepared_sas || sas_time < prepared_sas.time || (sas_time == prepared_sas.time && sas.order < prepared_sas.order)) {
						// Запоминаем ее как первую в очереди на отправку
						prepared_sas = {
							id : sas._id,
							time : sas_time,
							order : sas.order,
							sender : check_result.sender,
							rules : sas.rules
						};
					}
				}
			}

			S.sas_event = ''; // clear event flag

			// Если у нас есть что-то интересное в очереди на отправку
			if(prepared_sas) {
				var time_to_send;
				if((S.prepared_to_send && S.prepared_to_send.id == prepared_sas.id) && !S.prepared_to_send.rules.oper_out) {
					time_to_send = S.prepared_to_send.time;
				} else {
					time_to_send = prepared_sas.time;
				}
				var timeout_to_send = Math.max(0, (time_to_send - curtime)) * 1000;

				// Но отправка еще не сейчас
				if(time_to_send > curtime) {
					// Если эта рассылка уже не была подготовлена ранее к отправке или вообще никакая не была
					if(!S.prepared_to_send || S.prepared_to_send.id != sas._id) {
						S.prepared_to_send = prepared_sas; // Запомним ее
						Onicon.log('[sas] New sas prepared to send', S.prepared_to_send);
					} else { // Иначе мы работаем с рассчитанной ранее рассылкой
						Onicon.log('[sas] Old sas prepared to send', S.prepared_to_send);
					}
					// Делаем таймерчик на этот промежуток времени
					S.autosends_timer = setTimeout(S.sender, timeout_to_send);
				} else {
					// Иначе засылаем нашу дорогую авторассылку
					Onicon.log('[sas] Sender: send autosend ', prepared_sas, S.prepared_to_send);
					S.current_sending_autosend = prepared_sas;
					S.prepared_to_send = null;


                    var sas = S.autosends[prepared_sas.id];

					if (sas.title.indexOf('ag:') != -1) {

					    var d = document,
                            notification = d.getElementById('onicon-ag-notif'),
                            ag_sended = LS.get('ag-sended:'+C.channels.chat.channel_id+C.session_start) || {},
                            now = Math.floor((new Date().getTime()) / 1000),
                            expireAg = 60*60*2;

                        if (!notification) {
                            notification = d.createElement('div');
                            notification.id = 'onicon-ag-notif';
                            notification.classList.add('ag-hidden');
                            notification.onclick = function () {
                                notification.classList.add('ag-hidden');
                            };
                            document.body.appendChild(notification);
                        }

                        notification.innerHTML = sas.action.text;
                        ag_sended[sas._id] = now;

                        setTimeout(function () {
                            notification.classList.remove('ag-hidden');
                        }, 200);

                        setTimeout(function () {
                            notification.classList.add('ag-hidden');
                            if (S.current_sending_autosend && S.current_sending_autosend.id === sas._id) {
                                S.current_sending_autosend = null;
                                S.sender();
                            }
                        }, 10000);

                        LS.set('ag-sended:'+C.channels.chat.channel_id+C.session_start, ag_sended);

					} else {
						TR.send({
							flag: P.CLIENT_CODE_SASF_SEND,
							sas_id: prepared_sas.id,
							sender: prepared_sas.sender
						});
					}

                    // if ([
                    //         '4f168aa21ab7883c38000003',
                    //         '4edf4d7e1ab7881b10000065',
                    //         '56af63202866881f668b4577',
                    //         '53db6d9372d22c1a7b000055',
                    //         '5655818baba19aa8288b4567'
                    //     ].indexOf(_onc_ld_q.site_id) != -1) Onicon.rpc.call({
                    //     ctrl: "main",
                    //     action: "logSas",
                    //     params: {
                    //         id : prepared_sas.id,
                    //         time : prepared_sas.time,
                    //         order : prepared_sas.order,
                    //         sender_id : prepared_sas.sender.operator_id,
                    //         site_id: _onc_ld_q.site_id,
                    //         user_id: Onicon.core.user_id
                    //     }
                    // });
				}
			}
		},

		// Проверяет годится ли авторассылка для отправки
		_checkAutosend : function(sas, calculated_data) {
			var operatorsInSite =  function() {
				return !!C.channels.site.operators.length;
			};

			var operatorsInChat =  function() {
				return !!C.channels.chat.operators.length;
			};

			var operatorsOnline = function() {
				return operatorsInSite() || operatorsInChat();
			};

			var getAnySiteOperator = function(filter_array, prefered_id) {
				var arr = [], j = 0;
				for(var operator_id in S.operators) {
					if(filter_array && filter_array.length) {
						for(j = 0; j < filter_array.length; j++) {
							if(operator_id == filter_array[j]) {
								arr.push(operator_id);
							}
						}
					} else {
						if(S.operators[operator_id].mega_support || (S.operators[operator_id].first_name == 'Megagroup' && S.operators[operator_id].last_name == 'Support')) continue;
						if(S.operators[operator_id].deleted) continue;
                        arr.push(operator_id);
					}
				}

				if(arr.length) {
					if(prefered_id) {
						for(j = 0; j < arr.length; j++) {
							if(arr[j] == prefered_id && S.operators[prefered_id]) return S.operators[prefered_id];
						}
					}
					return S.operators[arr[rand(0, arr.length)]];
				} else {
					return null;
				}
			};

			var getOnlineSiteOperator = function(filter_array, prefered_id) {
				var op_arr = C.channels.site.operators, j = 0;

				var arr = [];
				for(var i = 0; i < op_arr.length; i++) {
					var operator_id = op_arr[i]._id;
					if(filter_array && filter_array.length) {
						for(j = 0; j < filter_array.length; j++) {
							if(operator_id == filter_array[j]) {
								arr.push(operator_id);
							}
						}
					} else {
						if(op_arr[i].mega_support || (op_arr[i].first_name == 'Megagroup' && op_arr[i].last_name == 'Support')) continue;
						arr.push(operator_id);
					}
				}

				if(arr.length) {
					if(prefered_id) {
						for(j = 0; j < arr.length; j++) {
							if(arr[j] == prefered_id && S.operators[prefered_id]) return S.operators[prefered_id];
						}
					}
					return S.operators[arr[rand(0, arr.length)]];
				} else {
					return null;
				}
			};

			var id = sas._id;
			var rules = sas.rules;
			var out_m = calculated_data.out_m, in_m = calculated_data.in_m;
			var curtime = Math.floor(+(new Date())/1000);
			var time_offset = 0;

			// Для начала проверяем, что атворассылка вообще включена
			if(!sas.enabled) {
				Onicon.log('[sas] Sender: autosend with id ' + id + ' was ignored by disabled flag');
				return false;
			}

            if (rules.direct_ad && !Onicon.core.direct_user) {
                return false;
            }

			if (rules.visitor_not_typing && S.typing) {
				Onicon.log('[sas] Sender: autosend with id ' + id + ' was ignored by visitor typing');
				return false;
			}

			if (rules.no_manual_messages && C.has_manual_messages) {
				Onicon.log('[sas] Sender: autosend with id ' + id + ' was ignored by no_manual_messages');
				return false;
			}

			// Проверка на кол-во входящих / исходящих сообщений
			if (rules.messages_count !== undefined) {
				if(isFinite(rules.messages_count)) {
					if(in_m > (rules.messages_count >> 16) || out_m > (rules.messages_count & 0xFFFF)) {
						Onicon.log('[sas] Sender: autosend with id ' + id + ' was ignored by numeric messages count');
						return false;
					}
				} else {
					var val = rules.messages_count.split(';');
					if(val && val.length && (in_m > val[0] || out_m > val[1])) {
						Onicon.log('[sas] Sender: autosend with id ' + id + ' was ignored by string messages count');
						return false;
					}
				}
			}

			// Проверка правил адреса страницы
			if (rules.page) {
				for (var l = 0; l < rules.page.length; ++l) {
					var pages_filter = rules.page[l].split(' ');
					var check = true;
					for(var i = 0; i < pages_filter.length; i++) {
						check = check && S._check(pages_filter[i], document.location.href);
					}
					if(check) {
						break;
					}

					if (l === rules.page.length - 1) {
						Onicon.log('[sas] Sender: autosend with id ' + id + ' was ignored by page url');
						return false;
					}
				}
			}

			// Проверка правил посещенных страниц
			if (rules.page_history) {
				for (var l = 0; l < rules.page_history.length; ++l) {
					var ph = C.pagesHistory();
					var data = rules.page_history[l].split(';', 2);
					var type = parseInt(data[0]);
					var urls = data[1].split(' ');
					var check = false;

					if(urls.length) {
						var strictCheck = function(pages_array, urls_array) {
							if( (pages_array.length != urls_array.length) || pages_array.length === 0 || urls_array.length === 0) {
								return false;
							}

							for(var i = 0; i < pages_array.length; i++) {
								if(pages_array[i]['url'].toLowerCase().indexOf(urls_array[i].toLowerCase()) === -1) {
									return false;
								}
							}

							return true;
						};

						var need_to_found = urls.length;
						switch(type) {
							case 0: // любая последовательность
								var matches = 0;
								while(urls.length) {
									var url = urls.shift();
									for(var p = 0; p < ph.length; p++) {
										if(ph[p]['url'].toLowerCase().indexOf(url.toLowerCase()) !== -1) {
											matches++;
											break;
										}
									}
								}

								check = (matches == need_to_found);
								break;

							case 1: // строгая последовательность
							case 2: // строгая последовательность в начале
							case 3: // строгая последовательность в конце
								for(var p = 0; p < ph.length; p++) {
									url = urls[0];
									if(ph[p].url.toLowerCase().indexOf(url.toLowerCase()) !== -1) {
										if(strictCheck(ph.slice(p, p+urls.length), urls)) {
											if(type == 1) {
												check = true;
											} else if(type == 2 && p == 0) {
												check = true;
											} else if(type == 3 && p == (ph.length - need_to_found)) {
												check = true;
											}

											if(check) {
												break;
											}
										}
									}
								}

								break;
						} // end switch

						if(check) {
							break;
						}

						if (l === rules.page_history.length - 1) {
							Onicon.log('[sas] Sender: autosend with id ' + id + ' was ignored by page history');
							return false;
						}
					}
				}
			}

			// Проверка правил заголовка страницы
			if (rules.title) {
				for (l = 0; l < rules.title.length; ++l) {
					if (S._checkTitle(rules.title[l])) {
						break;
					}

					if (l === rules.title.length - 1) {
						Onicon.log('[sas] Sender: autosend with id ' + id + ' was ignored by page title');
						return false;
					}
				}
			}

			// Проверка правил по региону
			if (rules.region) {
				for (l = 0; l < rules.region.length; ++l) {
					var region_filter = rules.region[l].split(' ');
					var check = true;
					for(var i = 0; i < region_filter.length; i++) {
						check = check && S._check(region_filter[i], C.region);
					}
					if(check) {
						break;
					}

					if (l === rules.region.length - 1) {
						Onicon.log('[sas] Sender: autosend with id ' + id + ' was ignored by region');
						return false;
					}
				}
			}

			// Проверка правил по зависимостям
			if (rules.dependence) {
				var dependence_flag = true;
				for (l = 0; l < rules.dependence.length; ++l) {
					var dep = rules.dependence[l].split(';');
					var dep_type = dep[0];
					var dep_id = dep[1];
					if (dep_type == 0 && calculated_data.sended_autosends[dep_id]) {
						dependence_flag = false;
					} else if(dep_type == 1 && !calculated_data.sended_autosends[dep_id]) {
						dependence_flag = false;
					}
				}

				if (!dependence_flag) {
					Onicon.log('[sas] Sender: autosend with id ' + id + ' was ignored by dependence type:' + dep_type + ' id:' + dep_id);
					return false;
				}
			}

			// Проверка правил по поисковому запросу
			var search_data = S._getSearchQuery();
			if (rules.search_query) {
				if(!search_data.query) {
					Onicon.log('[sas] Sender: autosend with id ' + id + ' was ignored by search_query:null');
					return false;
				}

				for (l = 0; l < rules.search_query.length; ++l) {
					if (search_data.query.toLowerCase().indexOf(rules.search_query[l].toLowerCase()) > -1) {
						break;
					}
					if (l === rules.search_query.length - 1) {
						Onicon.log('[sas] Sender: autosend with id ' + id + ' was ignored by search_query:no match');
						return false;
					}
				}
			}

			// Проверка количества смененных страниц
			if(rules.page_changes) {
				var rule_value = rules.page_changes.split(';');
				if(rule_value[0] && C.session_page_changes < rule_value[0]) {
					Onicon.log('[sas] Sender: autosend with id ' + id + ' was ignored by session page changes limit');
					return false;
				}

				if(rule_value[1] && C.total_page_changes < rule_value[1]) {
					Onicon.log('[sas] Sender: autosend with id ' + id + ' was ignored by total page changes limit');
					return false;
				}
			}

			// Проверка на максимальное количество авторассылок
			if(rules.autosends_count !== undefined) {
				if(calculated_data.as_m > rules.autosends_count) {
					Onicon.log('[sas] Sender: autosend with id ' + id + ' was ignored by autosends count');
					return false;
				}
			}

			var all_times_match = true;
			// Filter by start session (time in site)
			var session_time_match = true;
			if (rules.time_in_site !== undefined) {
				var limit_from = rules.time_in_site >> 16;
				var limit_to = rules.time_in_site & 0xFFFF;
				var seconds_in_site = curtime - DS.correct(C.session_start);

				if(limit_from && seconds_in_site < limit_from) {
					session_time_match = false;
				}

				if(!limit_to && limit_from) {
					limit_to = limit_from;
				}
				var session_time_offset = Math.max((DS.correct(C.session_start) + rand(limit_from, limit_to)) - curtime, 0);
				if(session_time_offset > time_offset) {
					time_offset = session_time_offset;
					Onicon.log('[sas] Sender: calc new time (session): ' + time_offset);
				}
			}

			var page_time_match = true;
			if (rules.time_in_page !== undefined) {
				var limit_from = rules.time_in_page >> 16;
				var limit_to = rules.time_in_page & 0xFFFF;
				var seconds_in_page = curtime - DS.correct(C.page_start);

				if(limit_from && seconds_in_page < limit_from) {
					page_time_match = false;
				}

				if(!limit_to && limit_from) {
					limit_to = limit_from;
				}
				var page_time_offset = Math.max((DS.correct(C.page_start) + rand(limit_from, limit_to)) - curtime, 0);
				if(page_time_offset > time_offset) {
					time_offset = page_time_offset;
					Onicon.log('[sas] Sender: calc new time (page): ' + time_offset);
				}
			}

			var last_autosend_time_match = true;
			if (rules.time_from_last_autosend !== undefined) {
				var limit_from = rules.time_from_last_autosend >> 16;
				var limit_to = rules.time_from_last_autosend & 0xFFFF;

				if(limit_from && calculated_data.last_autosend_time < limit_from) {
					page_time_match = false;
				}

				if(!limit_to && limit_from) {
					limit_to = limit_from;
				}
				var last_autosend_time_offset = Math.max((calculated_data.last_autosend_time + rand(limit_from, limit_to)) - curtime, 0);
				if(last_autosend_time_offset > time_offset) {
					time_offset = last_autosend_time_offset;
					Onicon.log('[sas] Sender: calc new time (last autosend): ' + time_offset);
				}
			}

			// Эта переменная используется при проверке событийных правил
			all_times_match = session_time_match && page_time_match && last_autosend_time_match;

			// Фильруем по режиму отправки (0 - оффлайн, 1 - онлайн, 2 - любой режим)
			if (sas.mode === 0 && operatorsOnline()) {
				Onicon.log('[sas] Sender: offline autosend with id ' + id + ' was ignored by because operators online');
				return false;
			} else if(sas.mode === 1 && !operatorsOnline()) {
				Onicon.log('[sas] Sender: online autosend with id ' + id + ' was ignored by because operators offline');
				return false;
			}

			var sender = {}, operator = null;
			// Фильтруем по отправителю
			// Для sender_type = 0 sas.operators будет содержать пустой массив и соответственно фильтрация
			// происходить не будет
			if (sas.sender_type === 0 || sas.sender_type === 1) { // отправлять от лица любого оператора
				if (rules.oper_out) { // удерживающее
					// и в чатике есть тот, кто написал последнее сообщение
					if(C.channels.chat.operators[calculated_data.last_operator_id]) {
						// он и будет отправителем
						operator = C.channels.chat.operators[calculated_data.last_operator_id];
					} else {
						// если нет выцепим любого оператора
						operator = getAnySiteOperator(sas.operators, calculated_data.last_operator_id);
						//Onicon.log('[sas] Sender: oper_out last operator is go offline');
						//return false;
					}
				} else { // обычная авторассылка
					switch(sas.mode) {
						case 0: // если это чисто оффлайн авторассылка
							operator = getAnySiteOperator(sas.operators, calculated_data.last_operator_id);
							break;
						case 1: // чисто онлайн
							operator = getOnlineSiteOperator(sas.operators, calculated_data.last_operator_id);
							if(!operator) {
								operator = getAnySiteOperator(sas.operators, calculated_data.last_operator_id);
							}
							break;
						case 2: // смешанная
							if(C.current_state === C.STATE_ONLINE) {
								operator = getOnlineSiteOperator(sas.operators, calculated_data.last_operator_id);
							} else {
								operator = getAnySiteOperator(sas.operators, calculated_data.last_operator_id);
							}
							break;
					}
				}

				if(!operator) {
					Onicon.log('[sas] Sender: online autosend with id ' + id + ' was ignored, possible operator not found');
					return false;
				}

				sender = {
					operator_id : operator._id,
					name: ''
				}
			} else {
				sender = {
					operator_id : 0,
					name: sas.sender_name
				};
			}

			// Process "event" rules, such as event_typing
			var event_mode = 0; // no events for autosend
			var event_delay = 0;
			for(var rule_name in rules) {
				if(rules.hasOwnProperty(rule_name) && rule_name.match('event_') && rules[rule_name] !== undefined) {
					// If we have event in rules, set mode to 1
					if(event_mode == 0) {
						event_mode = 1; // event mode enabled
					}
					// If event match current triggered event, set 2
					if(rule_name == S.sas_event) {
						event_mode = 2; // current event
						event_delay = parseInt(rules[rule_name]);
						break; // There is no need to search more
					}
				}
			}

			if(event_mode == 1) { // If events enabled and not match / not found
				Onicon.log('[sas] Not this event: ' + S.sas_event);
				return false; // Skip this autosend for the future
			} else if(event_mode == 2) {
				if(all_times_match) {
					time_offset = 0; // If Event match and time limits match, trigger autosend now
				} else {
					Onicon.log('[sas] Event: times doesnt match: ' + S.sas_event);
					return false; // Skip this autosend for the future
				}
			}

			// Проверка модификаторов переотправки сообщения по сессии или времени
			if (calculated_data.sended_autosends[sas._id]) {
				var last_send_time = calculated_data.sended_autosends[sas._id];
				if (!rules.resend && !rules.every_session && !rules.oper_out && !rules.resendsec) {
					Onicon.log('[sas] Sender: autosend with id ' + id + ' was ignored by already sended');
					return false;
				}

				if (rules.resend) {
					time_offset = Math.max(last_send_time - curtime + rules.resend * 3600, 0);
					Onicon.log('[sas] Sender: calc new time by resend: ' + time_offset + ' (last: ' + last_send_time + ', resend: ' + rules.resend + ', curtime: ' + curtime + ')');
				}

        if (rules.resendsec) {
          time_offset = Math.max(last_send_time - curtime + rules.resendsec, 0);
          Onicon.log('[sas] Sender: calc new time by resendsec: ' + time_offset + ' (last: ' + last_send_time + ', resend: ' + rules.resendsec+ ', curtime: ' + curtime + ')');
        }

				if (rules.every_session && C.session_start <= last_send_time) {
					Onicon.log('[sas] Sender: autosend with id ' + id + ' was ignored by already sended in current session');
					return false;
				}
			}

			// По расписанию
			if (rules.schedule) {
				var val = rules.schedule;
				if (!Onicon.core['can' + val.charAt(0).toUpperCase() + val.slice(1)]) return false;
			}

			// Удерживающие сообщение работает только в онлайн режиме
			if (rules.oper_out) {
				var last_visitor_mess = calculated_data.last_visitor_message,
					last_oper_mess = calculated_data.last_operator_message;

				if (last_visitor_mess == 0) {
					Onicon.log('[sas] Sender: autosend with id ' + id + ' was ignored by oper_out rule; visitor has no sended messages');
					return false;
				}

				//Если последнее сообщение было за оператором, то ничего не отправляем
				if (last_oper_mess > last_visitor_mess) {
					Onicon.log('[sas] Sender: autosend with id ' + id + ' was ignored by oper_out rule; operator already answered');
					return false;
				}

				time_offset = (last_visitor_mess + +rules.oper_out) - curtime;
				Onicon.log('[sas] Sender: calc new time by oper out: ' + time_offset);
			} else if(operatorsInChat()) {
				// диалог взят оператором и нет условия форсированной отправки авторассылки (например, оператор не отвечает в течение какого-либо времени)
				Onicon.log('[sas] Sender: the dialog have operator now');
				return false;
			}

			time_offset = Math.max(time_offset, 0);

			return {
				sas_id : sas._id,
				time_offset : time_offset,
				sender : sender
			};
		},

		_check: function (rule_string, string_to_check) {
			var check;
			// отрицание
			var negative_search = (rule_string.indexOf('!') === 0);
			if(negative_search) {
				rule_string = rule_string.substr(1);
			}

			// строгая проверка
			var strict_search = (rule_string.indexOf('#') === 0);
			if(strict_search) {
				rule_string = rule_string.substr(1);
			}

			if(strict_search) {
				check = (string_to_check.toLowerCase() == rule_string.toLowerCase());
			} else {
				check = (string_to_check.toLowerCase().indexOf(rule_string.toLowerCase()) !== -1);
			}

			if(check && !negative_search) {
				return true;
			} else if(!check && negative_search) {
				return true;
			}

			return false;
		},

		_checkTitle : function(rule_title) {
			if(document.title && document.title.match(rule_title)) {
				return true;
			} else {
				return false;
			}
		},


		_parseUrl: function (str) {
			var key = ['source', 'scheme', 'authority', 'userInfo', 'user', 'pass', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'fragment'],
				m = /^(?:([^:\/?#]+):)?(?:\/\/()(?:(?:()(?:([^:@]*):?([^:@]*))?@)?([^:\/?#]*)(?::(\d*))?))?()(?:(()(?:(?:[^?#\/]*\/)*)()(?:[^?#]*))(?:\?([^#]*))?(?:#(.*))?)/.exec(str),
				uri = {}, i = 0;

			while (++i < key.length) {
				if (m[i]) uri[key[i]] = m[i];
			}

			return uri;
		},

		_getSearchQuery : function(str) {
			str = str || document.referrer;
			var engines = [
				[/^http:\/\/(?:www\.)?google/ig, 'q', 'Google'],
				[/^http:\/\/(?:www\.)?ya\.ru/ig, 'text', 'Yandex'],
				[/^http:\/\/(?:www\.)?yandex/ig, 'text', 'Yandex'],
				[/^http:\/\/(?:www\.)?nova.rambler\.ru/ig, 'query', 'Rambler'],
				[/^http:\/\/(?:www\.)?mail\.ru/ig, 'q', 'Mail.ru'],
				[/^http:\/\/(?:www\.)?gogo\.ru'/ig, 'q', 'gogo'],
				[/^http:\/\/(?:www\.)?yahoo\.com/ig, 'p', 'Yahoo!'],
				[/^http:\/\/(?:www\.)?megasearch\.oml\.ru/ig, 'q', 'MegaSearch']
			];

			var engine = null;
			var query = null;
			for(var i = 0; i < engines.length; i++) {
				var e = engines[i];
				var match = e[0].exec(str);
				if(match && match[0]) {
					engine = e[2];
					var match_query = (new RegExp(e[1] + '=([^&]+)', 'ig')).exec(str);
					if(match_query && match_query.length == 2) {
						query = match_query[1];
					}
				}

				if(engine && query) {
					break;
				}
			}

			return {
				engine: engine,
				query: query
			};
		}
	};

	Onicon.lib('sas', S, true);
}());
